var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.alumno.nombre)+" "+_vm._s(_vm.alumno.apellido))]),_c('td',[_vm._v(_vm._s(_vm.alumno.es_alumno_de.nombre)+" "+_vm._s(_vm.alumno.es_alumno_de.apellido))])])
}
var staticRenderFns = []

export { render, staticRenderFns }